/** Shared chrome for Guardians side-panel footer actions. */
export const panelActionHeightClass = "h-9";

export const panelActionBaseClass =
  "inline-flex items-center justify-center rounded-lg px-3 text-sm font-medium";

export const panelActionCoreClass = "inline-flex items-center justify-center text-sm font-medium";

export const panelActionSecondaryClass = `${panelActionBaseClass} ${panelActionHeightClass} bg-slate-800 text-slate-200 hover:bg-slate-700`;

export const panelActionSecondaryMutedClass = `${panelActionBaseClass} ${panelActionHeightClass} bg-slate-800 text-slate-300 hover:bg-slate-700`;

export const panelActionOutlineClass = `${panelActionBaseClass} ${panelActionHeightClass} border border-white/10 bg-slate-800/60 text-slate-200 hover:bg-slate-700`;

export const panelActionRowClass = "flex flex-wrap items-center gap-2";
